/**
 * A data de hoje (AAAA-MM-DD) no fuso de quem está usando.
 *
 * `new Date().toISOString()` dá a data em UTC: no Brasil (UTC−3), a partir
 * das 21h ela já é a de amanhã. O registro de aula abria com a data do dia
 * seguinte para quem lançava à noite, e a trava de "data futura" deixava
 * passar o dia seguinte.
 */
export function hojeLocal(agora = new Date()) {
  const ano = agora.getFullYear();
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}
